<template>
  <div class="BigBox">
    <Header></Header>
    <div class="content">
      <div
        style="
          width: 100%;
          text-align: center;
          font-size: 20px;
          font-weight: bold;
          padding-bottom: 26px;
        "
      >
        使用条款
      </div>
      <div class="text">请在使用本网站前仔细阅读本使用条款。</div>
      <div class="text">
        本网站归属施乐辉医用产品国际贸易（上海）有限公司（以下简称“施乐辉”或“我们”），仅用于提供与施乐辉相关的信息。施乐辉有权不时更新本使用条款。使用本网站都表明您同意遵守此使用条款所述内容。如果您不同意本使用条款，请不要使用本网站。
      </div>
      <div class="text">
        本网站不提供医疗建议，本网站提供的信息大部分与施乐辉的服务有关。如果您需要诊断或治疗，您应该随时和医护人员沟通。
      </div>
      <div class="text">
        施乐辉未就本网站上的信息或内容做出任何形式或性质的陈述或保证。在任何情形下，施乐辉对任何形式或性质的任何损害赔偿均不承担责任。
      </div>
      <div class="text">
        出于本条款之目的，本网站上公布的信息、文件和相关图表应视为归施乐辉独家拥有。您不得以任何形式侵犯该等知识产权及相关权利。
      </div>
      <div class="text">
        本网站可能包含连接至非施乐辉运营网站的链接。我们提供此类链接是为了方便用户，但我们不会审查、控制或监测任何其他网站上的材料。此类网站可能包含未经批准的产品或疗法的使用信息。对于此类信息，我们不予控制或宣传。我们不对此类网站的性能或您与其的业务往负责。您对其他网站的使用须遵守此类网站的使用条款，包括其隐私政策。
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../components/FooterNav.vue";
import Header from "../components/HeaderNav.vue";
export default {
  components: {
    Footer,
    Header,
  },
  filters: {
    // 过滤时间为年月日时分秒
    date1(time) {
      let padDate = function (num) {
        num = num < 10 ? "0" + num : num;
        return num;
      };
      let value = new Date(time);
      let year = value.getFullYear();
      let month = padDate(value.getMonth() + 1);
      let day = padDate(value.getDate());
      let hour = padDate(value.getHours());
      let minutes = padDate(value.getMinutes());
      let seconds = padDate(value.getSeconds());
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
  },
  data() {
    return {};
  },
  methods: {},
  created() {
    window.scroll(0, 0);
    // 记录log
    // let leavetime = this.$options.filters['date1'](new Date());
    // this.$http.post('api/UserAccessLog',{
    // 	action: "legalPage.vue",
    // 	leaveDate: leavetime,
    // 	loginDate: leavetime,
    // 	objectId: "",
    // 	objectType: "",
    // 	openID: this.$store.state.openid,
    // 	remark: "PC端法律声明页",
    // 	type: "legalPage.vue",
    // 	unionID: "",
    // 	userId: this.$store.state.userInfo.userId,
    // }).then(res=>{
    // 	console.log(res)
    // }).catch(error=>{
    // 	console.log(error)
    // })
  },
};
</script>

<style scoped="scoped">
.BigBox {
  /* width: 100%; */
  /* background-color: #f6f6f6; */
  /* min-height: 100vh;
		padding-bottom: 6%;
		position: relative; */
}
.img {
  width: 100%;
}
.container {
  background-color: #f6f6f6;
}
.content {
  display: inline-block;
  background: #ffffff;
  /* box-shadow: 0px 4px 4px rgba(210, 210, 210, 0.25);
  border-radius: 14px; */
  margin: 20px 20px;
  padding: 26px;
  font-size: 14px;
  line-height: 22px;
  color: #333;
}
.content .text {
  margin-bottom: 15px;
}
</style>
